//const URL = process.env.NODE_ENV === 'production' ? 'https://api.ep.new.zhiliaoep.com/' : 'http://localhost:21021/';
const URL = process.env.NODE_ENV === 'production' ? 'https://api.ep.new.zhiliaoep.com/' : 'https://api.ep.new.zhiliaoep.com/';
export default URL;